import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { Entity__get_Name, Entity__get_Id } from "../ClientTypes.fs.js";
import { Subsystems_MoveToSystem, Subsystems_UpdateSubsystem, Subsystems_CreateSubsystem } from "../ServerTypes.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { moveSystem, update as update_1, create as create_2 } from "../Api/Subsystems.fs.js";
import { Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { stringHash, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { tryHead, length, map, singleton, cons, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { EntitySelector } from "../components/EntitySelector.fs.js";
import { List_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { unwrap } from "../fable_modules/fable-library-js.4.24.0/Option.js";

export function Create(createInputProps) {
    let xs_12, elms_1, elms, elms_3, elms_2, elms_4;
    const close = createInputProps.close;
    const projectId = createInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const detail = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const systemOpt = patternInput_3[0];
    let create_1;
    const dependencies_1 = [name, detail, systemOpt];
    create_1 = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const matchValue = isNullOrWhiteSpace(name);
            let matchResult, system;
            if (systemOpt != null) {
                if (matchValue) {
                    matchResult = 1;
                }
                else {
                    matchResult = 0;
                    system = systemOpt;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const taskId = newGuid();
                    taskDispatch(new TaskMsg(0, [taskId, "Create"]));
                    const create = new Subsystems_CreateSubsystem(name, Entity__get_Id(system), detail);
                    taskDispatch(new TaskMsg(2, [taskId]));
                    return create_2(projectId, create).then((_arg) => {
                        const result = _arg;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [taskId, undefined]));
                            return Promise.resolve();
                        }
                    });
                }
                default: {
                    return Promise.resolve();
                }
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_12 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        })), (elms_4 = ofArray([createElement("label", {
            className: "label",
            children: "System",
        }), createElement(EntitySelector, {
            projectId: projectId,
            entityType: "system",
            onSelectedEntityChange: patternInput_3[1],
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_4)),
        }))], react.createElement(react.Fragment, {}, ...xs_12)),
        submit: create_1,
        submitText: "Create",
        tasks: patternInput[0],
        title: "Create",
    });
}

export function Update(updateInputProps) {
    let xs_10, elms_1, elms, elms_3, elms_2;
    const close = updateInputProps.close;
    const subsystem = updateInputProps.subsystem;
    const projectId = updateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(subsystem.Name);
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState(subsystem.Detail);
    const detail = patternInput_2[0];
    let updates;
    const dependencies_1 = [name, detail];
    updates = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, `Update ${name}`]));
                const update = new Subsystems_UpdateSubsystem(name, detail);
                taskDispatch(new TaskMsg(2, [taskId]));
                return update_1(projectId, subsystem.Id, update).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_10 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        }))], react.createElement(react.Fragment, {}, ...xs_10)),
        submit: updates,
        submitText: "Update",
        tasks: patternInput[0],
        title: "Update",
    });
}

export function MoveToSystem(moveToSystemInputProps) {
    let elms;
    const close = moveToSystemInputProps.close;
    const subsystems = moveToSystemInputProps.subsystems;
    const projectId = moveToSystemInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const systemOpt = patternInput_1[0];
    let initialSystem;
    const dependencies_1 = [subsystems];
    initialSystem = reactApi.useMemo(() => {
        const systemIds = map((m) => m.SystemId, subsystems);
        if (length(List_groupBy((x) => x, systemIds, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: stringHash,
        })) > 1) {
            return undefined;
        }
        else {
            return tryHead(systemIds);
        }
    }, dependencies_1);
    let moves;
    const dependencies_1_1 = [systemOpt];
    moves = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (systemOpt == null) {
                return Promise.resolve();
            }
            else {
                const sys = systemOpt;
                const move = new Subsystems_MoveToSystem(Entity__get_Id(sys));
                return PromiseBuilder__For_1565554B(promise, subsystems, (_arg) => {
                    const subsystem = _arg;
                    taskDispatch(new TaskMsg(0, [subsystem.Id, `Move ${subsystem.Name} To System : ${Entity__get_Name(sys)}`]));
                    taskDispatch(new TaskMsg(2, [subsystem.Id]));
                    return moveSystem(projectId, subsystem.Id, move).then((_arg_1) => {
                        const result = _arg_1;
                        if (result.tag === 1) {
                            taskDispatch(new TaskMsg(6, [subsystem.Id, result.fields[0]]));
                            return Promise.resolve();
                        }
                        else {
                            taskDispatch(new TaskMsg(3, [subsystem.Id, undefined]));
                            return Promise.resolve();
                        }
                    });
                });
            }
        }));
        void pr;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "System",
        }), createElement(EntitySelector, {
            projectId: projectId,
            entityType: "system",
            initialEntity: unwrap(initialSystem),
            onSelectedEntityChange: patternInput_1[1],
            isSmall: false,
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: moves,
        submitText: "Move",
        tasks: patternInput[0],
        title: "Move To System",
    });
}

